/* eslint-disable no-undef */
/*
 * @Desc: 迅雷新实名认证
 * @Author: hxc
 * @Date: 2017-09-06 16:09:47
 * @Last Modified by: jinying.lin
 * @Last Modified time: 2017-12-07 17:12:26
 */

/**
 * 实名认证类
 * @requires 迅雷实名认证组件
 */
export class RealNameAuth2 {
  /**
   * 依赖库
   * @see https://static2-youxi.a.88cdn.com/backend/xl-lib/xl-game-realname-sdk-2.0.0.min.js
   */
  constructor(options) {
    this.requirePluginUrl =
      '//static2-youxi.a.88cdn.com/backend/xl-lib/xl-game-realname-sdk-2.0.0.min.js'
    this.options = {
      scene: 'pay',
      succfn() {},
      failfn() {},
      mountedFn() {},
      unmountedFn() {}
    }
    this.handleOptions(options)
    this.init()
  }

  /**
   * 处理配置项
   * @param options 配置项
   */
  handleOptions(options) {
    $.extend(true, this.options, options)
  }

  /**
   * 初始化
   */
  async init() {
    await this.getPluginScript()
    this.initRealNameAuth()
  }

  getPluginScript() {
    /**
     * 已加载依赖的插件
     */
    if (
      typeof (window.xlGameRealname && window.xlGameRealname.authBase) !==
      'undefined'
    ) {
      return Promise.resolve()
    }
    return f2eGame.util.loadData({
      url: `${this.requirePluginUrl}?t=${new Date().getTime()}`,
      dataType: 'script'
    })
  }

  /**
   * 初始化迅雷实名认证
   */
  initRealNameAuth() {
    const {
      scene = 'pay',
      gameId = 'default',
      succfn = function() {},
      failfn = function() {},
      mountedFn = function() {},
      unmountedFn = function() {}
    } = this.options
    const appid =
      window._SDKCommonConf.xlAppId || '596af11482f747c2a72ac8463b2f8000'
    const bizid =
      window._SDKCommonConf.gamesBizidList[gameId] ||
      window._SDKCommonConf.gamesBizidList.default
    const isShowClose = scene === 'pay'
    window.xlGameRealname.authBase(appid, bizid, {
      // 可选，实名认证弹窗是否显示关闭按钮，默认不显示
      isShowClose,
      // 可选，认证成功的回调方法
      onSuccess: succfn,
      // 可选，认证失败的回调方法
      onFail: failfn,
      // 可选，弹窗出现时的回调方法
      onShow: mountedFn,
      // 可选，弹窗隐藏时的回调方法
      onHide: unmountedFn
    })
  }
}
